import isEmpty from "../../is-Empty";
import Validator from "validator";

export const OtpValidation = (data) => {
  let errors = {};

  data.otp = !isEmpty(data.otp) ? data.otp : "";

  if (Validator.isEmpty(data.otp)) {
    errors.otp = "Please Enter Otp";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
